export default __webpack_public_path__ + "static/bold-neutrals-dark-c18a45727a59209960bdd0605de8ad99.png";